import {
  createSemanticMetrics,
  createUniversalReporter,
  MetricTypes,
  Nanoseconds,
  Tags,
} from '@spotify-internal/semantic-metrics';
import { createRouteMetrics } from '@spotify-internal/next-router-metrics';

export enum DataFetchOutcome {
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum Whats {
  PAGE_REQUEST = 'page-request',
  DATA_FETCH = 'data-fetch',
  RESPONSE_TIME = 'data-response-time',
  SERVER_ERROR = 'server-error',
  PAGE_404 = 'page-404',
  MISSING_DATA = 'missing-data',
  SEARCH_DROPDOWN = 'search-dropdown',
  ARTICLE_SEARCH = 'article-search',
  EXPERIMENTATION_REMOTE_CONFIG = 'ep-remote-config',
  EXPERIMENTATION_REMOTE_CONFIG_WEBHOOK = 'ep-remote-config-webhook',
  EXPERIMENTATION_REMOTE_CONFIG_TIME = 'ep-remote-config-time',
}

const { sendMetric } = createSemanticMetrics({
  key: 'support-site-web',
  reporter: createUniversalReporter(),
  // Uncomment these two lines to send events locally, instantly
  // dev: false,
  // batching: false,
});

const withRouteMetrics = createRouteMetrics(sendMetric);

const sendTimerMetric = (what: string, value: Nanoseconds<number>, tags?: Tags) => {
  sendMetric({
    metric_type: MetricTypes.TIMER,
    what,
    value,
    tags,
  });
};

const sendCounterMetric = (what: string, tags?: Tags) => {
  sendMetric({
    metric_type: MetricTypes.COUNTER,
    what,
    value: 1,
    tags,
  });
};

export { sendMetric, sendCounterMetric, sendTimerMetric, withRouteMetrics };
